<mat-spinner [diameter]="diam()"></mat-spinner>

